import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';
import * as SiteManager from '../domain/site-manager';
import { DeviceListData } from '../../types/device';

export type Device = DeviceListData;

type ContextState = Data<DeviceListData[]>;

const Context = React.createContext<ContextState | null>(null);

function useDevicesData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDevicesData must be used within a DevicesDataProvider');
    }
    return contextState;
}

const DevicesDataProvider: React.FC<{ locationId: string } | { organizationId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const id = 'locationId' in props ? props.locationId : 'organizationId' in props ? props.organizationId : '';

    const { dataset } = useData({
        cacheKey: 'device-list',
        id: id,
        dataFn: React.useCallback(
            () => SiteManager.getDevices(authHelper, { siteId: id, recursive: true, status: true }),
            [authHelper, id]
        ),
    });
    const deviceList = dataFromDataset(dataset);

    return <Context.Provider value={deviceList}>{props.children}</Context.Provider>;
};

const TestDevicesDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DevicesDataProvider, TestDevicesDataProvider, useDevicesData };
